import { VideoForm } from '../../components/VideoForm/VideoForm';
import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { Copy } from '../../copy/Copy';

export const AddVideo = () => (
  <PageContainer title={Copy.generate('Global.addVideo')}>
    <VideoForm />
  </PageContainer>
);
